import { Box, Flex, Spinner, Text } from "@radix-ui/themes";
import { FileType, UploadItem } from "./UploadItem";
import { useIES } from "../../hooks/useIES";

const UploadImages = () => {
  const { IES, isLoading } = useIES();

  // Sem `useState`: guardar isto em estado congelava os valores da primeira
  // renderização e deixava de acompanhar o `useIES`.
  const uploads: { type: FileType; initialPreview?: string }[] = [
    { type: "favicon", initialPreview: IES.FAVICON },
    { type: "logo", initialPreview: IES.LOGO },
    { type: "background", initialPreview: IES.BACKGROUND },
  ];

  if (isLoading) {
    return (
      <Flex align="center" justify="center" p="5">
        <Spinner loading />
      </Flex>
    );
  }

  return (
    <Box p="5" style={{ maxWidth: "1200px" }}>
      <Text as="p" color="gray" size="2" mb="4">
        Carregue as imagens que serão utilizadas no sistema
      </Text>
      {uploads.map((item) => (
        <UploadItem
          key={item.type}
          type={item.type}
          initialPreview={item.initialPreview}
        />
      ))}
    </Box>
  );
};

export default UploadImages;
